import { getModelos, deleteModelo } from "@spark/services/frotas";
import { useState, useEffect, useCallback, useRef } from 'react';
import { notification } from '@spark/ui-components/utils/notification';

export const useModelosListagem = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterLoading, setFilterLoading] = useState(false);
  const [totalRegistros, setTotalRegistros] = useState(0);
  const [paginaAtual, setPaginaAtual] = useState(1);
  const [quantidadePorPagina, setQuantidadePorPagina] = useState(5);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [modeloToDelete, setModeloToDelete] = useState(null);
  const isMountedRef = useRef(true);
  const [filtros, setFiltros] = useState({
    search: '',
    situacao: '',
    codigoTipoModeloVeicular: '',
    unidadeCapacidade: '',
    codigoTipoCargaANTT: '',
    codigoIntegracao: '',
    nomeTipoModeloVeicular: '',
    ocupacaoCubicaPallets: '',
    ocupacaoCubicaMaxima: '',
    quantidadePallet: '',
    capacidadeMaximoPallets: '',
    toleranciaMinimaPallets: '',
    toleranciaMinimaCarregamento: '',
    numeroEixos: '',
    capacidadeModelo: '',
    quantidadeExtraExcedenteTolerado: '',
    toleranciaExtra: ''
  });

  useEffect(() => {
    isMountedRef.current = true;

    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const fetchData = useCallback(async (filtrosParaBuscar = filtros) => {
    if (!isMountedRef.current) return;

    try {
      setLoading(true);
      const filters = {
        page: paginaAtual,
        limit: quantidadePorPagina,
        ...(filtrosParaBuscar.search && { search: filtrosParaBuscar.search }),
        ...(filtrosParaBuscar.situacao && { situacao: filtrosParaBuscar.situacao }),
        ...(filtrosParaBuscar.codigoTipoModeloVeicular && { codigoTipoModeloVeicular: filtrosParaBuscar.codigoTipoModeloVeicular }),
        ...(filtrosParaBuscar.unidadeCapacidade && { unidadeCapacidade: filtrosParaBuscar.unidadeCapacidade }),
        ...(filtrosParaBuscar.codigoTipoCargaANTT && { codigoTipoCargaANTT: filtrosParaBuscar.codigoTipoCargaANTT }),
        ...(filtrosParaBuscar.codigoIntegracao && { codigoIntegracao: filtrosParaBuscar.codigoIntegracao }),
        ...(filtrosParaBuscar.nomeTipoModeloVeicular && { nomeTipoModeloVeicular: filtrosParaBuscar.nomeTipoModeloVeicular }),
        ...(filtrosParaBuscar.ocupacaoCubicaPallets && { ocupacaoCubicaPallets: filtrosParaBuscar.ocupacaoCubicaPallets }),
        ...(filtrosParaBuscar.ocupacaoCubicaMaxima && { ocupacaoCubicaMaxima: filtrosParaBuscar.ocupacaoCubicaMaxima }),
        ...(filtrosParaBuscar.quantidadePallet && { quantidadePallet: filtrosParaBuscar.quantidadePallet }),
        ...(filtrosParaBuscar.capacidadeMaximoPallets && { capacidadeMaximoPallets: filtrosParaBuscar.capacidadeMaximoPallets }),
        ...(filtrosParaBuscar.toleranciaMinimaPallets && { toleranciaMinimaPallets: filtrosParaBuscar.toleranciaMinimaPallets }),
        ...(filtrosParaBuscar.toleranciaMinimaCarregamento && { toleranciaMinimaCarregamento: filtrosParaBuscar.toleranciaMinimaCarregamento }),
        ...(filtrosParaBuscar.numeroEixos && { numeroEixos: filtrosParaBuscar.numeroEixos }),
        ...(filtrosParaBuscar.capacidadeModelo && { capacidadeModelo: filtrosParaBuscar.capacidadeModelo }),
        ...(filtrosParaBuscar.quantidadeExtraExcedenteTolerado && { quantidadeExtraExcedenteTolerado: filtrosParaBuscar.quantidadeExtraExcedenteTolerado }),
        ...(filtrosParaBuscar.toleranciaExtra && { toleranciaExtra: filtrosParaBuscar.toleranciaExtra })
      };

      const responseData = await getModelos(filters);
      if (!isMountedRef.current) return;

      const registros = Array.isArray(responseData?.registros) ? responseData.registros : [];

      const dadosProcessados = registros.map((item) => ({
        id: item.id ?? item.Id ?? item.idModelo ?? item.IdModelo,
        codigo: item.codigo ?? item.Codigo,
        descricao: item.descricao ?? item.Descricao,
        nomeTipoModeloVeicular: item.nomeTipoModeloVeicular ?? item.NomeTipoModeloVeicular,
        codigoTipoModeloVeicular: item.codigoTipoModeloVeicular ?? item.CodigoTipoModeloVeicular,
        unidadeCapacidade: item.unidadeCapacidade ?? item.UnidadeCapacidade,
        capacidadeModelo: item.capacidadeModelo ?? item.CapacidadeModelo,
        numeroEixos: item.numeroEixos ?? item.NumeroEixos,
        ocupacaoCubicaPallets: item.ocupacaoCubicaPallets ?? item.OcupacaoCubicaPallets,
        ocupacaoCubicaMaxima: item.ocupacaoCubicaMaxima ?? item.OcupacaoCubicaMaxima,
        quantidadePallet: item.quantidadePallet ?? item.QuantidadePallet,
        capacidadeMaximoPallets: item.capacidadeMaximoPallets ?? item.CapacidadeMaximoPallets,
        toleranciaMinimaCarregamento: item.toleranciaMinimaCarregamento ?? item.ToleranciaMinimaCarregamento,
        codigoIntegracao: item.codigoIntegracao ?? item.CodigoIntegracao,
        situacao: item.situacao ?? item.Situacao,
        toleranciaMinimaPallets: item.toleranciaMinimaPallets ?? item.ToleranciaMinimaPallets,
        quantidadeExtraExcedenteTolerado: item.quantidadeExtraExcedenteTolerado ?? item.QuantidadeExtraExcedenteTolerado,
        toleranciaExtra: item.toleranciaExtra ?? item.ToleranciaExtra
      }));

      setData(dadosProcessados);
      setTotalRegistros(responseData?.totalRegistros ?? 0);
    } catch (error) {

    } finally {
      if (isMountedRef.current) setLoading(false);
    }
  }, [filtros, paginaAtual, quantidadePorPagina]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleFilterApply = useCallback((newFilters) => {
    setFiltros(newFilters);
    setPaginaAtual(1);
    setFilterLoading(true);
    fetchData(newFilters).finally(() => {
      if (isMountedRef.current) setFilterLoading(false);
    });
  }, [fetchData]);

  const handleLimparFiltros = useCallback((clearedFilters) => {
    setFiltros(clearedFilters);
    setPaginaAtual(1);

    setFilterLoading(true);
    fetchData(clearedFilters).finally(() => {
      if (isMountedRef.current) setFilterLoading(false);
    });
  }, [fetchData]);

  const handleExcluir = useCallback((id) => {
    const modelo = data.find((i) => i.id === id);
    setModeloToDelete({
      id,
      descricao: modelo?.descricao || id
    });
    setShowDeleteModal(true);
  }, [data]);

  const confirmDelete = useCallback(async () => {
    if (!modeloToDelete) return;
    try {
      await deleteModelo(modeloToDelete.id);
      notification.success('Modelo excluído com sucesso!');
      setShowDeleteModal(false);
      setModeloToDelete(null);
      fetchData();
    } catch (error) {
      console.error('❌ Erro ao excluir modelo:', error);
    }
  }, [modeloToDelete, fetchData]);

  const cancelDelete = useCallback(() => {
    setShowDeleteModal(false);
    setModeloToDelete(null);
  }, []);

  return {
    data,
    loading,
    filterLoading,
    totalRegistros,
    paginaAtual,
    quantidadePorPagina,
    showDeleteModal,
    pedidoToDelete: modeloToDelete,
    handleFilterApply,
    handleLimparFiltros,
    handleExcluir,
    confirmDelete,
    cancelDelete,
    setPaginaAtual,
    setQuantidadePorPagina
  };
};
